import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

$(document).ready(function () {
	let perView = 2.5;

	if ($('.product-slider-swiper-container').data('item-count') < 3) {
		perView = $('.product-slider-swiper-container').data('item-count');
	}

	const productSwiper = new Swiper('.product-slider-swiper-container', {
		loop: false,
		spaceBetween: 22,
		grabCursor: true,
		breakpoints: {
			768: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: perView,
			},
		},
		navigation: {
			nextEl: ".product-slider-swiper-button-next",
			prevEl: ".product-slider-swiper-button-prev",
		},
		modules: [Navigation],
	});
});

